<template>
  <!--
      	作者：gmshop
      	时间：2020-06-25
      	描述：插件中心-限时拼团-项目列表-编辑项目-其它
      -->
  <div>
    <div class="common-form">其它</div>
    <el-form-item label="项目规则介绍" prop="summary" :rules="[{ required: true, message: '请输入项目规则介绍' }]">
      <el-input type="textarea" v-model="form.summary" autosize class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目规则介绍视频" prop="video_path" >
      <div>
        <el-button type="primary" @click="openVideoUpload">上传视频</el-button>
        <video :src="form.video_path" class="mt10" width="120px;" height="120px" v-if="isVideo" :isVideo="isVideo" controls="controls" style="display: block;" />
        <!--上传图片组件-->
        <Video v-if="isvideoupload" :config="{ total: 1 }" :isvideoupload="isvideoupload" @returnImgs="returnVideoFunc">上传视频</Video>
      </div>
    </el-form-item>
    <el-form-item label="项目排序" :rules="[{ required: true, message: '请输入项目排序' }]" prop="sort">
      <div class="max-w460">
        <el-input v-model="form.sort" type="number"></el-input>
      </div>
    </el-form-item>
    <el-form-item label="是否生效">
      <el-radio-group v-model="form.status">
        <el-radio :label="0">未生效</el-radio>
        <el-radio :label="1">生效</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>

<script>
  import Video from '@/components/file/Video';
export default {
  components: {
    Video: Video,
  },
  data(){
    return{
      isvideoupload:false,
      isVideo: false,
    };
  },
  props: ['form'],
  created() {
    this.isVideo = this.form.isVideo;
    console.log(this.isVideo,213)
  },
  methods:{
    /*上传视频*/
    openVideoUpload() {
      this.isvideoupload = true;
    },

    /*获取视频*/
    returnVideoFunc(e) {
      let self = this;
      if (e != null) {
        this.form.video_id = e[0].file_id;
        this.form.video_path = e[0].file_path;
        this.isVideo = true;
      }
      this.isvideoupload = false;
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/task/task/part/Other.vue